import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProfileHeader = ({ profileData, completionPercentage, onSave, onPublish, onDownload, isSaving }) => {
  return (
    <div className="bg-card rounded-xl shadow-warm-md border border-border p-4 md:p-6 lg:p-8 mb-6">
      <div className="flex flex-col lg:flex-row gap-6 items-start lg:items-center">
        <div className="relative">
          <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-primary/20">
            <Image
              src={profileData?.avatar}
              alt={profileData?.avatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
          <button
            className="absolute bottom-0 right-0 w-10 h-10 bg-primary text-primary-foreground rounded-full flex items-center justify-center shadow-warm-md hover:bg-primary/90 transition-smooth"
            aria-label="Change profile picture"
          >
            <Icon name="Camera" size={20} />
          </button>
        </div>

        <div className="flex-1 w-full lg:w-auto">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
            <div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-card-foreground mb-2">
                {profileData?.name}
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                {profileData?.email} • {profileData?.phone}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <div className="relative w-16 h-16">
                <svg className="transform -rotate-90 w-16 h-16">
                  <circle
                    cx="32"
                    cy="32"
                    r="28"
                    stroke="var(--color-muted)"
                    strokeWidth="6"
                    fill="none"
                  />
                  <circle
                    cx="32"
                    cy="32"
                    r="28"
                    stroke="var(--color-primary)"
                    strokeWidth="6"
                    fill="none"
                    strokeDasharray={`${2 * Math.PI * 28}`}
                    strokeDashoffset={`${2 * Math.PI * 28 * (1 - completionPercentage / 100)}`}
                    strokeLinecap="round"
                  />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="text-sm font-semibold text-card-foreground">
                    {completionPercentage}%
                  </span>
                </div>
              </div>
              <div className="text-sm">
                <p className="font-medium text-card-foreground">Profile</p>
                <p className="text-muted-foreground">Complete</p>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap gap-3">
            <Button
              variant="default"
              iconName="Save"
              iconPosition="left"
              onClick={onSave}
              loading={isSaving}
            >
              Save Draft
            </Button>
            <Button
              variant="success"
              iconName="Upload"
              iconPosition="left"
              onClick={onPublish}
            >
              Publish Profile
            </Button>
            <Button
              variant="outline"
              iconName="Download"
              iconPosition="left"
              onClick={onDownload}
            >
              Download Resume
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;